import { render, staticRenderFns } from "./project-handover-list.vue?vue&type=template&id=51cdc852&scoped=true&"
import script from "./project-handover-list.vue?vue&type=script&lang=js&"
export * from "./project-handover-list.vue?vue&type=script&lang=js&"
import style0 from "./project-handover-list.vue?vue&type=style&index=0&id=51cdc852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cdc852",
  null
  
)

export default component.exports